import { makeStyles } from '@mui/styles';
import commonStyle from '../common-style';

export const useStyles = makeStyles((theme) => ({
  ...commonStyle,
}))
